export default __webpack_public_path__ + "static/media/LearningCenterPicture.2f14ceec.jpg";